import React from 'react';
import AppRouter from 'common/AppRouter';
import { Route, Switch } from 'react-router-dom';
import { ACCOUNT_TYPES_MAP } from '@linearb/linjs-common';
import { Surveys } from 'views/root/views/home/views/surveys/Surveys';
import Home from 'views/root/views/home';
import { IAccount } from 'types/account';

interface PostOnboardingProps {
  account?: IAccount;
}

/**
 * PostOnboarding component that handles routing after user onboarding
 * @param {PostOnboardingProps} props - Component props
 * @param {IAccount} props.account - User account information
 * @returns {JSX.Element} PostOnboarding component
 */
const PostOnboarding: React.FC<PostOnboardingProps> = ({ account }) => {
  if (!account) {
    return null;
  }

  return (
    <Switch>
      {account.type_id === ACCOUNT_TYPES_MAP.External ? (
        <Route
          path={`${AppRouter.SURVEYS_EXECUTION.path}*`}
          render={() => <Surveys />}
          exact
        />
      ) : (
        <Route path={AppRouter.ROOT.path} component={Home} />
      )}
    </Switch>
  );
};

export default PostOnboarding;
